<header>
  <div class="container-fluid responsive-fixed-header px-0 wow fadeIn" data-wow-delay="0.1s">
<nav #navbar class="navbar navbar-expand-lg py-lg-0 px-lg-5 wow fadeIn" data-wow-delay="0.1s">
<a href="index.html" class="navbar-brand ms-4 ms-lg-0">
            <img src="assets/img/mykadainew.png" class="mykadai-logo"
                 >
        </a>
        <button type="button" class="navbar-toggler me-4" (click)="toggleNavbar()">
            <span class="navbar-toggler-icon">
                <i class="bi bi-list h1" [ngClass]="isNavbarCollapsed ? 'text-black' : 'text-black'"></i>
            </span>
        </button>
        <div [ngClass]="{ 'collapse navbar-collapse': true, show: !isNavbarCollapsed }" id="navbarCollapse">
            <div class="navbar-nav ms-auto p-4 p-lg-0">
                <a routerLink="/" fragment="home" class="nav-item nav-link active">Home</a>
            </div>
        </div>
    </nav>
</div>
</header>
<!-- NAVBAR (Sidebar toggle for mobile) -->
<nav class="navbar navbar-dark sticky-top d-lg-none py-3 nav-content">
  <div class="container-fluid">
    <a class="navbar-brand text-white fw-semibold">Table of Contents</a>
    <button
      class="navbar-toggler"
      type="button"
      (click)="toggleSidebar()"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
</nav>

<!-- Offcanvas Sidebar (for mobile) -->
<div
  class="offcanvas offcanvas-start text-bg-dark"
  tabindex="-1"
  [class.show]="isSidebarOpen"
  (click)="closeSidebar()"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">Table of Contents</h5>
    <button
      type="button"
      class="btn-close btn-close-white"
      (click)="closeSidebar()"
    ></button>
  </div>
  <div class="offcanvas-body p-3">
    <!-- same sidebar content -->
    <ul class="list-unstyled mb-0">
      <li class="mt-3">
        <h5>Product Upload Workflow</h5>
         <ul class="list-unstyled mb-0">
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Introduction"
              >Introduction</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="shop-registration"
              >Shop Registration</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Shop-Setup-Workflow"
              >Shop Setup Workflow</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="My-Shop-Products"
              >My Shop Products</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="My-Orders"
              >My Orders</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Payments"
              >Payments</a
            >
          </li>
           <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/product-upload"
              fragment="Upload Screen"
              >Upload Screen</a
            >
          </li>
         </ul>
      </li>
    </ul>
  </div>
</div>

<div class="d-flex manual-layout">
  <!-- Sidebar -->
  <aside class="sidebar text-white p-3 top-0 start-0 vh-100 d-none d-lg-block">
    <h4 class="fw-semibold mb-3 pt-lg-5 mt-lg-3 pt-0 mt-0">
      Table of Contents
    </h4>
   <ul class="list-unstyled mb-0">      
      <li class="mt-3">
        <h5>Product Upload Workflow</h5>
         <ul class="list-unstyled mb-0">
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Introduction"
              >Introduction</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="shop-registration"
              >Shop Registration</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Shop-Setup-Workflow"
              >Shop Setup Workflow</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="My-Shop-Products"
              >My Shop Products</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="My-Orders"
              >My Orders</a
            >
          </li>
          <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              routerLink="/vendor-app"
              fragment="Payments"
              >Payments</a
            >
          </li>
           <li class="mb-1">
            <a
              class="text-white text-decoration-none d-block px-2 pb-1 rounded"
              (click)="goToUploadScreen()"
              role="button"
              >Upload Screen</a
            >
          </li>
         </ul>
      </li>
    </ul>
  </aside>
  <!-- Main Content -->
  <main class="flex-grow-1 bg-light">
    <section class="manual-details bg-white p-4 rounded shadow-sm">
      <article id="Upload-Screen">
        <h3>MyKadai Product Upload Manual</h3>

      <div class="note text-danger">
        <strong>Note:</strong> This document explains how to upload products to
        the MyKadai console using an Excel sheet.
      </div>

      <ol>
        <li>
          Login to MyKadai console as shop owner with your credentials.
        </li>

        <li>
          You can see <strong>Product Upload</strong> button on the sidebar.
        </li>

        <div class="img-box text-center my-3">
          <img
            src="assets/img/manual/product-upload.png"
            alt="Product Upload Menu"
            class="img-fluid my-3 rounded shadow-sm border"
          />
        </div>

        <li>Click on <strong>Product Upload</strong>.</li>

        <li>
          You will be able to see the template file for uploading products via
          Excel. Kindly download the sheet.
        </li>

        
          <div class="img-box text-center my-3">
            <img
              src="assets/img/manual/download-template.png"
              alt="Product Upload Template"
              class=" rounded shadow-sm border"
            />
          </div>
        

     <!--Table-->
        <!-- <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Product Name</th>
                <th scope="col">Product Description</th>
                <th scope="col">Main Category Name</th>
                <th scope="col">Sub Category Name</th>
                <th scope="col">Shop Product MRP</th>
                <th scope="col">Shop Product SRP</th>
                <th scope="col">GST</th>
                <th scope="col">Quantity Value</th>
                <th scope="col">Quantity Type</th>
                <th scope="col">Short Product Description</th>
                <th scope="col">Brand Name</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td></td><td></td><td></td><td></td><td></td>
                <td></td><td></td><td></td><td></td><td></td><td></td>
              </tr>
              <tr>
                <td></td><td></td><td></td><td></td><td></td>
                <td></td><td></td><td></td><td></td><td></td><td></td>
              </tr>
              <tr>
                <td></td><td></td><td></td><td></td><td></td>
                <td></td><td></td><td></td><td></td><td></td><td></td>
              </tr>
              <tr>
                <td></td><td></td><td></td><td></td><td></td>
                <td></td><td></td><td></td><td></td><td></td><td></td>
              </tr>
              <tr>
                <td></td><td></td><td></td><td></td><td></td>
                <td></td><td></td><td></td><td></td><td></td><td></td>
              </tr>
              <tr>
                <td></td><td></td><td></td><td></td><td></td>
                <td></td><td></td><td></td><td></td><td></td><td></td>
              </tr>
            </tbody>
          </table>
        </div> -->
     

        <li>
          As per the columns in the sheet, fill the details.
          <strong>Kindly don’t change the field names or column order.</strong>
        </li>

        <li>Once you enter the data, save it as an Excel file.</li>

        <li>
          In the product upload screen, you can see the following options:

          <div class="img-box text-center my-3">
            <img
              src="assets/img/manual/shop-product-upload.png"
              alt="Upload Excel File"
              class="img-fluid my-3 rounded shadow-sm border"
            />
          </div>

          <ul class="sub-points">
            <li>Select the shop name in the first dropdown.</li>
            <li>Choose and upload the Excel file.</li>
            <li>Click the <strong>Upload</strong> button.</li>
            <li>
              Once done, your Excel data will be entered into products in your
              shop.
            </li>
          </ul>
        </li>
        <li>
          Once you upload the Excel file, you can see the data in
          <strong>My Shop Products</strong> menu.
        </li>

        <li>
          Click the <strong>Edit</strong> button to edit the product details,
          upload an image, or alter the price.
        </li>

        <li>
          Once you’re done, your products will be shown to customers in the
          MyKadai app.
        </li>
      </ol>
      </article>
    </section>
  </main>
</div>
